import { Providers } from '@/app/providers';
import { Router } from '@/app/Router';

/**
 * Root application component.
 * Wraps the Router with all necessary Providers.
 */
export function App(): JSX.Element {
  return (
    <Providers>
      <Router />
    </Providers>
  );
}
